export const EN_LANG = 'en';
export const NB_LANG = 'nb';
